import { TranslateService } from '@ngx-translate/core';
import { PrivacyPolicyPage } from '../privacy-policy/privacy-policy';
import { TermServicesPage } from '../term-services/term-services';
import { RefundPolicyPage } from '../refund-policy/refund-policy';
import { NavController, NavParams, ModalController,Content } from 'ionic-angular';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { SingleSurveyPage } from '../survey/survey';
import { CreateTechSurveyPage } from '../create-tech-survey/create-tech-survey';
import { ConfigProvider } from '../../providers/config/config';
import { LoadingProvider } from '../../providers/loading/loading';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { CartPage } from '../cart/cart';
import { Component, Input, EventEmitter, Output, OnInit ,ViewChild,Inject, LOCALE_ID } from '@angular/core';
import { SearchPage } from '../search/search';
import swal from 'sweetalert';
import { AlertProvider } from '../../providers/alert/alert';
import { HomePage } from '../home/home';
//import * as Survey from 'survey-angular';
import { Http } from '@angular/http';
import { Geolocation } from '@ionic-native/geolocation';
import { CalendarComponent } from "ionic2-calendar/calendar";


@Component({
  selector: 'lead-detail-page',
  templateUrl: 'lead-detail-page.html',
})
export class LeadDetailPage {
  @ViewChild(CalendarComponent, null) myCal:CalendarComponent;

  loadedLeads = new Array;
  lead = { contact:{id:''}};
  appointments: { [k: string]: any } = {};
  customer: { [k: string]: any } = {};
  customFields = {};
  leaddetail: string = "contact";
  smsToSend:string = "";
  totalmessages = new Array;
  inmessages = new Array;
  outmessages = new Array;
  errorMessage = '';
  goHighLevelLeads = new Array;
  public currentEvents = [
    {
      year: 2021,
      month: 4,
      date: 15,
      eventCSS:'red-one'
    },

  ];

  event = {
   title: '',
   desc: '',
   startTime: '',
   endTime: '',
   allDay: false
 };

 minDate = new Date().toISOString();

 eventSource = [];
 viewTitle;

 calendar = {
   mode: 'month',
   currentDate: new Date(),
 };


  constructor(
    @Inject(LOCALE_ID) private locale: string,


    public modalCtrl: ModalController,
    public config: ConfigProvider,
    public navParams: NavParams,
    public navCtrl: NavController,
    public loading: LoadingProvider,
    public iab: InAppBrowser,
    translate: TranslateService,
    public http: Http,
    private geolocation: Geolocation,
    public alert: AlertProvider,
    public shared: SharedDataProvider
  ) {

    this.lead = navParams.get('lead');

  }
getAllAppointments(){
  this.getAppointments();
  console.log("EventSource:",this.eventSource);


}

next() {
 var swiper = document.querySelector('.swiper-container')['swiper'];
 swiper.slideNext();
}

back() {
 var swiper = document.querySelector('.swiper-container')['swiper'];
 swiper.slidePrev();
}

// Change between month/week/day
changeMode(mode) {
 this.calendar.mode = mode;
}

// Focus today
today() {
 this.calendar.currentDate = new Date();
}

// Selected date reange and hence title changed
onViewTitleChanged(title) {
 this.viewTitle = title;
}

// Calendar event was clicked
async onEventSelected(event) {
  // Use Angular date pipe for conversion
  //let start = formatDate(event.startTime, 'medium', this.locale);
  //let end = formatDate(event.endTime, 'medium', this.locale);

  //const alert = await this.alert.create({
  //  header: event.title,
//    subHeader: event.desc,
//    message: 'From: ' + event.startTime + '<br><br>To: ' + event.endTime,
//    buttons: ['OK']
//  });
//  alert.present();
}

getAppointments(){
  console.log("Get Appointments");
  var data: { [k: string]: any } = {};
  console.log("Getting contact for:",this.lead);
  data.customer_id = this.lead.contact.id;
  data.ghl_token = this.shared.customerData.ghl_token;
  this.loading.show();
  this.http.post(this.config.url + 'getAppointmentsForUser', data).map(res => res.json()).subscribe(data => {

    if (data.success == 1) {
      this.loading.hide();
      console.log("Got Appointments:",data.appointments);
      this.appointments = data.appointments;
      this.appointments.events.forEach(function(value, key) {

          var startDate = new Date(value.startTime.replace(/\s/g, "T"));
          var endDate =new Date(value.endTime.replace(/\s/g, "T"));
          var event = {
             title: value.title,
             desc: 'Test Desc',
             startTime: startDate,
             endTime: endDate,
             allDay: false
           };

          this.eventSource.push(event);
          this.myCal.loadEvents();

      }.bind(this));


      }
    });


}


ionViewWillEnter() {

}

SendSMS(){
  var data: { [k: string]: any } = {};
  var message: { [k: string]: any } = {};
  console.log("Send SMS:",this.smsToSend );
  console.log("Number to send:",this.customer.phone );


  data.token = this.shared.customerData.tw_token;
  data.sid = this.shared.customerData.tsid;
  data.fromNumber = this.shared.customerData.tw_number
  data.toNumber = this.customer.phone;
  data.body = this.smsToSend ;

  this.http.post(this.config.url + 'sendSMS', data).map(res => res.json()).subscribe(data => {
    this.loading.hide();
    if (data.success == 1) {
      var date = Date();
      message.body = this.smsToSend;
      message.direction = "outbound-api";
      message.date_sent = date;

      console.log("Response:",data);
      console.log(this.totalmessages );
      this.totalmessages.push(message);
      this.smsToSend = "";
      //this.content.scrollToBottom();
      }
    });



}

StartQuote(){
  console.log("Start Quote:",this.customer);

  this.getCustomer(this.lead);
  this.navCtrl.push(HomePage, { lead: this.customer });

}


getCustomer(lead){

  var data: { [k: string]: any } = {};
  console.log("Getting contact for:",lead);
  data.customer_id = lead.id;
  data.ghl_token = this.shared.customerData.ghl_token;
  this.loading.show();
  this.http.post(this.config.url + 'getCustomer', data).map(res => res.json()).subscribe(data => {

    if (data.success == 1) {
      this.customer = data.customer.contact;
      this.customFields = data.customFields;
      console.log("Got Customer:",this.customer);
      console.log("Got Custom Fields:",this.customFields);

      this.getSMSHistory(this.customer);


      }
    });


}

sortFunction(a,b){
  var dateA = new Date(a.date_sent).getTime();
  var dateB = new Date(b.date_sent).getTime();
  return dateA > dateB ? 1 : -1;
}

getSMSHistory(customer){

  var data: { [k: string]: any } = {};
  console.log("Getting SMS Log for:",customer);

  data.token = this.shared.customerData.tw_token;
  data.sid = this.shared.customerData.tsid;
  data.fromNumber = customer.phone;
  data.toPhone = "+19497511871";

  this.http.post(this.config.url + 'getSMSHistory', data).map(res => res.json()).subscribe(data => {
    this.loading.hide();
    if (data.success == 1) {
      console.log("Got SMS Inbound:",data.inboundmessages);
        console.log("Got SMS Outbound:",data.outboundmessages);
      this.inmessages = data.inboundmessages;
      this.outmessages = data.outboundmessages;
      this.totalmessages = this.inmessages.concat(this.outmessages);
      this.totalmessages = this.totalmessages.sort(this.sortFunction);







      }
    });


}

ngOnInit() {

this.getCustomer(this.lead);

}

}



// WEBPACK FOOTER //
// ./src/pages/lead-detail-page/lead-detail-page.ts